import { motion } from "framer-motion";

const CHAPTERS = [
  { n: "01", title: "Sub-Arcminute Precision", body: "Zero backlash is not a luxury — it is the baseline for modern cobotic repeat precision and trajectory accuracy. Every component we source is validated against arc-second tolerances." },
  { n: "02", title: "Direct Sourcing Integrity", body: "We partner directly with tier-1 manufacturers — Cubemars, Laifual, Leaderdrive, Howming — bringing global engineering standards straight to Indian robotics and automation hubs." },
  { n: "03", title: "End-to-End Joint Integration", body: "From frameless torque motors and hollow-shaft encoders to fully integrated harmonic actuators, we supply complete motion assemblies engineered and ready for deployment." },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] } }),
};

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative py-24 lg:py-36 tech-grid" data-testid="manifesto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-10 h-px bg-signal" />
              <span className="font-mono text-[11px] tracking-[0.35em] uppercase text-signal">The Approach</span>
            </div>
            <h2 className="font-head font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] text-white">
              Built on the<br />mechanics of<br /><span className="text-signal">absolute control.</span>
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p className="text-slate-400 text-lg leading-relaxed">
              Dashmesh Enterprises exists at the intersection of global precision engineering and India's
              fast-scaling robotics industry. Three principles drive everything we distribute.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {CHAPTERS.map((c, i) => (
            <motion.div key={c.n} custom={i} variants={reveal} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
              className="group relative bg-card border border-white/10 p-8 hover:border-signal/40 transition-colors" data-testid={`chapter-${c.n}`}>
              <div className="font-head font-black text-7xl text-white/5 group-hover:text-signal/20 transition-colors absolute top-4 right-5 leading-none">{c.n}</div>
              <div className="font-mono text-xs text-signal tracking-widest mb-6">CHAPTER {c.n}</div>
              <h3 className="font-head font-bold uppercase text-2xl text-white mb-4 relative z-10">{c.title}</h3>
              <p className="text-slate-400 leading-relaxed relative z-10">{c.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
